import axios from "axios";
export async function checkTranslationCertificate(id) {
    await axios.get(`/api/translation-certificate/confirm/${id}`);
}
